import { useCallback, useEffect } from 'react';

export const handleKeyDown = <T extends Element>(e: React.KeyboardEvent<T>, action: () => void) => {
   if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
   }
};

export const useKeyboardHandler = () =>
   useCallback(<T extends Element>(e: React.KeyboardEvent<T>, action: () => void) => {
      handleKeyDown(e, action);
   }, []);

export const useEscapeKey = (callback: () => void, isActive: boolean = true) => {
   useEffect(() => {
      if (!isActive) return;

      const handleEscKey = (event: KeyboardEvent) => {
         if (event.key === 'Escape') {
            callback();
         }
      };

      document.addEventListener('keydown', handleEscKey);
      return () => {
         document.removeEventListener('keydown', handleEscKey);
      };
   }, [callback, isActive]);
};

export const useEnterKeySubmit = (submitHandler: () => void, isDisabled: boolean = false) => {
   return useCallback(
      (event: KeyboardEvent) => {
         if (!isDisabled && event.key === 'Enter') {
            event.preventDefault();
            submitHandler();
         }
      },
      [isDisabled, submitHandler]
   );
};
